import React, { useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import { IHandlers, IProps } from 'app/common/RangeSlider/types';
import { useSelector } from 'react-redux';
import { DiaryRootState } from 'appRoot/rootReducer';

const useStyles = makeStyles({
  root: {
    width: 300,
    marginLeft: 20,
  },
  labelContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  }
});

function valuetext(value: number) {
  return `${value}`;
}

export default function RangeSlider({handleChange}: IProps & IHandlers) {
  const settings = useSelector((state: DiaryRootState) => state.floorplanSettingsReducer.floorplanSettings);
  const initialData = [+settings.minBookingSlotsAvailability || 60, +settings.maxBookingSlotsAvailability || 120]

  const classes = useStyles();
  const [value, setValue] = React.useState<number[]>(initialData);

  const _handleChange = (event: any, newValue: number | number[]) => {
    setValue(newValue as number[]);
    handleChange && handleChange(newValue as number[]);
  };
  useEffect(() => {
    setValue([+settings.minBookingSlotsAvailability || 60, +settings.maxBookingSlotsAvailability || 120])
  }, [settings]);
  return (
    <div className={classes.root}>
      <AvailabilitySlider
        value={value}
        onChange={_handleChange}
        valueLabelDisplay="on"
        valueLabelFormat={(value) => {
          return `${value} mins`
        }}
        aria-labelledby="range-slider"
        getAriaValueText={valuetext}
        step={5}
        min={30}
        max={180}
      />
    </div>
  );
}

const AvailabilitySlider = withStyles({
  valueLabel: {
    '& *': {
      background: 'transparent',
      color: '#000',
      whiteSpace: 'nowrap',
      marginTop: '10px',
      fontSize: '14px'
    },
  }
})(Slider);